import { ExclamationIcon } from "@heroicons/react/outline";

import { formatDate } from "./utils";

import { SpanNode } from "@/types/spans";

const formatEventTimestamp = (timestamp: number) => {
  if (!Number.isFinite(timestamp)) {
    return "Unknown time";
  }

  const date = new Date(timestamp / 1_000_000);

  if (Number.isNaN(date.getTime())) {
    return "Unknown time";
  }

  return formatDate(date.toISOString());
};

const Exceptions = ({ span }: { span: SpanNode }) => {
  const exceptionEvents = span.events.filter(event => event.name === "exception");

  if (exceptionEvents.length === 0) {
    return null;
  }

  return (
    <section className="border-t border-gray-200 pt-5">
      <div className="mb-2">
        <h4 className="text-sm font-medium text-gray-900">Exceptions</h4>
        <p className="mt-1 text-xs text-gray-500">
          {exceptionEvents.length} captured{" "}
          {exceptionEvents.length === 1 ? "exception" : "exceptions"}
        </p>
      </div>
      <div className="space-y-3">
        {exceptionEvents.map((event, index) => (
          <div
            // eslint-disable-next-line react/no-array-index-key
            key={index}
            className="rounded-lg bg-red-50/70 px-3 py-2.5"
          >
            <div className="flex flex-wrap items-center gap-2">
              <span className="inline-flex items-center rounded-full border border-red-200 bg-white px-2 py-0.5 text-xs font-medium text-red-700">
                <ExclamationIcon className="mr-1 h-3.5 w-3.5" />
                {event.attributes?.["exception.type"] || "Exception"}
              </span>
              <span className="text-xs text-gray-500">{formatEventTimestamp(event.timestamp)}</span>
            </div>
            {event.attributes?.["exception.message"] && (
              <div className="mt-2">
                <p className="text-[11px] font-medium uppercase tracking-[0.08em] text-gray-500">
                  Message
                </p>
                <p className="mt-1 whitespace-pre-wrap break-words text-sm text-gray-800">
                  {event.attributes["exception.message"]}
                </p>
              </div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};

export default Exceptions;
